import React, { useState } from 'react';

import ModalComponent from '../../../../../common-components/ModalComponent/ModalComponent';

import './_signContractModal.scss';

import SavedSignatures from './SavedSignatures';
import TypeSignature from './TypeSignature';
import UploadContractSignature from './UploadContractSignature';

const tabs = {
  uploadImage: 'upload-image',
  type: 'type',
  saved: 'saved',
};

export default function SignContractModal({ isOpen, onClose, onUploadFinish, isInfluencerSigning }) {
  const [tab, setTab] = useState(tabs?.uploadImage);
  const isMobile = window.innerWidth <= 768;

  /*
  userSignatureMeta
  {
      type: 'typed',
      text: typeSignatureFormData?.name,
      fontFamily: typeSignatureFormData?.selectedStyle,
      _id: string
  };
  {
      type: 'image',
      src: string,
      _id: string
  };
  */
  const _onUploadFinish = (userSignatureMeta) => {
    onUploadFinish(userSignatureMeta);
  };

  let selectedTab = (
    <UploadContractSignature
      isInfluencerSigning={isInfluencerSigning}
      onClose={onClose}
      onUploadFinish={_onUploadFinish}
    />
  );
  if (tab === tabs.type) {
    selectedTab = (
      <TypeSignature isInfluencerSigning={isInfluencerSigning} onClose={onClose} onUploadFinish={_onUploadFinish} />
    );
  } else if (tab === tabs.saved) {
    selectedTab = <SavedSignatures onClose={onClose} onUploadFinish={_onUploadFinish} />;
  }

  return (
    <>
      <ModalComponent
        show={isOpen}
        onClose={onClose}
        width={isMobile ? 340 : 650}
        outsideClickClose={false}
        style={{ zIndex: 9999, padding: 0 }}
        bodyStyle={{ padding: 0 }}>
        <div className="sign-contract-modal-container">
          <div>
            <div className="sign-contract-modal-header">
              <h5>Add signature</h5>
            </div>

            <div className="sign-contract-tabs">
              <button
                type="submit"
                className={`sign-contract-tab ${tab === tabs.uploadImage ? 'sign-contract-tab-active' : ''}`}
                onClick={() => {
                  setTab(tabs.uploadImage);
                }}>
                Upload Image
              </button>

              <button
                type="submit"
                className={`sign-contract-tab ${tab === tabs.type ? 'sign-contract-tab-active' : ''}`}
                onClick={() => {
                  setTab(tabs.type);
                }}>
                Type
              </button>

              {isInfluencerSigning ? null : (
                <button
                  type="submit"
                  className={`sign-contract-tab ${tab === tabs.saved ? 'sign-contract-tab-active' : ''}`}
                  onClick={() => {
                    setTab(tabs.saved);
                  }}>
                  Saved
                </button>
              )}
            </div>
          </div>

          {selectedTab}
        </div>
      </ModalComponent>
    </>
  );
}
